module.exports = __webpack_public_path__ + "static/media/card-open-claw-br.c5fd687c.png";